import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AnalyticsRouteTracker } from '@/components/analytics/AnalyticsRouteTracker'
import { AppRoutes } from '@/routes'
import { ScrollToTop } from '@/components/layout/ScrollToTop'
import { StoreGateProvider } from '@/contexts/StoreGateContext'
import { useAuthStore } from '@/stores/authStore'
import { BRAND_GOLD } from '@/lib/brand'

function App() {
  const initAuth = useAuthStore((s) => s.initAuth)

  useEffect(() => {
    const unsubscribe = initAuth()
    return unsubscribe
  }, [initAuth])

  return (
    <BrowserRouter>
      <AnalyticsRouteTracker />
      <StoreGateProvider>
        <ScrollToTop />
        <AppRoutes />
      </StoreGateProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#141414',
            color: '#e4e4e7',
            border: '1px solid #3d3d3d',
            borderRadius: '12px',
          },
          success: {
            iconTheme: { primary: BRAND_GOLD.primary, secondary: '#000000' },
          },
        }}
      />
    </BrowserRouter>
  )
}

export default App
